import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { AvaProvider } from "@/context/AvaContext";
import { HiveProvider } from "@/context/HiveContext";
import { Layout } from "@/components/Layout";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import GoogleCallback from "@/pages/GoogleCallback";
import AvaSso from "@/pages/AvaSso";
import Dashboard from "@/pages/Dashboard";
import SuperBrain from "@/pages/SuperBrain";
import FormationAdvisor from "@/pages/FormationAdvisor";
import Briefing from "@/pages/Briefing";
import Matchday from "@/pages/Matchday";
import LiveMatch from "@/pages/LiveMatch";
import LiveVideo from "@/pages/LiveVideo";
import HiveFeed from "@/pages/HiveFeed";
import DataIngest from "@/pages/DataIngest";
import PlayerHealth from "@/pages/PlayerHealth";
import LeagueExplorer from "@/pages/LeagueExplorer";
import OctonConsole from "@/pages/OctonConsole";
import Fixtures from "@/pages/Fixtures";
import CodexLibrary from "@/pages/CodexLibrary";
import { Toaster } from "sonner";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#050505]">
        <div className="h-14 w-14 rounded-full border-2 border-cyan-400/30 border-t-cyan-400 animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/auth/google" element={<GoogleCallback />} />
      <Route path="/ava-sso" element={<AvaSso />} />
      <Route element={<Protected><Layout /></Protected>}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/super-brain" element={<SuperBrain />} />
        <Route path="/advisor" element={<FormationAdvisor />} />
        <Route path="/briefing" element={<Briefing />} />
        <Route path="/matchday" element={<Matchday />} />
        <Route path="/live" element={<LiveMatch />} />
        <Route path="/live-video" element={<LiveVideo />} />
        <Route path="/hive" element={<HiveFeed />} />
        <Route path="/ingest" element={<DataIngest />} />
        <Route path="/fixtures" element={<Fixtures />} />
        <Route path="/health" element={<PlayerHealth />} />
        <Route path="/leagues" element={<LeagueExplorer />} />
        <Route path="/console" element={<OctonConsole />} />
        <Route path="/codex" element={<CodexLibrary />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AvaProvider>
            <HiveProvider>
              <AppRouter />
              <Toaster theme="dark" position="top-center" />
            </HiveProvider>
          </AvaProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
